import { useMemo, useCallback } from 'react';

export const useLinkPresenter = ({ href }) => {
  const hasHref = useMemo(() => {
    return !!href && href !== '#';
  }, [href]);

  const isButton = useMemo(() => {
    return !hasHref;
  }, [hasHref]);

  const getIconSize = useCallback((size) => {
    return ['xs', 's'].includes(size) ? 's' : 'm';
  }, []);

  return {
    hasHref,
    isButton,
    getIconSize,
  };
};
